import React from 'react'
import HomeBanner from "./HomeBanner"
import HomeTeamlogo from "./HomeTeamlogo"
import HomeCar from "./HomeCar";
import HomeLab from "./HomeLab";
import HomeSolution from "./HomeSolution";
import HomeSoftware from "./HomeSoftware";
import HomeBusiness from "./HomeBusiness";
import HomePlatform from "./HomePlatform";
import HomeTestimonial from "./HomeTestimonial";
import HomePrice from "./HomePrice";
import HomeGlobal from "./HomeGlobal";
import HomeNews from "./HomeNews";

const headText = "Our Client Testimonials";

export default function Home({initialData}) {

  return (
    <>
      <HomeBanner />
      <HomeTeamlogo initialData={initialData?.logos} />
      <HomeCar />
      <HomeLab />
      <HomeSolution />
      <HomeSoftware />
      <HomeBusiness />
      <HomePlatform />
      <HomeTestimonial headText={headText} initialData={initialData?.video_testimonials} />
      <HomePrice />
      <HomeGlobal />
      <HomeNews />
    </>
  );
}
